var map = {
	"./bgu.png": 557,
	"./guy-koren.png": 216,
	"./guy-koren.psd": 943,
	"./mada.svg": 318,
	"./matrix.png": 480,
	"./ministry-of-defense.svg": 795,
	"./mixtiles.png": 938,
	"./rounds.png": 784
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 971;